import React from "react"
import withStyles from "react-jss"
import { AnswerButton, Card } from "."

const styles = {
  heading: {
    // width: "100%",
    maxWidth: "650px",
    color: (props) => props.colors.heading,
    padding: "0 4rem",
    textAlign: "center",
    fontSize: "calc(22px + (32 - 22) * ((100vw - 300px) / (1600 - 300)))",
  },
  grid: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    flexWrap: "wrap",
  },
  row: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
    "@media only screen and (max-width: 810px)": {
      justifyContent: "center",
      alignItems: "center",
    },
  },
}

const Question = ({ classes, data, colors, updateChoice }) => {
  const renderOptions = (qId, options, lockAnswer) => {
    if (options.length === 4 || options.length === 3) {
      return (
        <>
          <div className={classes.row}>
            {options.slice(0, 2).map((option, i) => (
              <AnswerButton
                key={i}
                data={option}
                lockAnswer={lockAnswer}
                onClick={() => updateChoice(qId, option.optionId)}
              />
            ))}
          </div>
          <div className={classes.row}>
            {options.slice(2, 4).map((option, i) => (
              <AnswerButton
                key={i}
                data={option}
                lockAnswer={lockAnswer}
                onClick={() => updateChoice(qId, option.optionId)}
              />
            ))}
          </div>
        </>
      )
    }
    // length === 2 || n
    return (
      <div className={classes.row}>
        {options.map((option, i) => (
          <AnswerButton
            key={i}
            data={option}
            lockAnswer={lockAnswer}
            onClick={() => updateChoice(qId, option.optionId)}
          />
        ))}
      </div>
    )
  }

  return (
    <Card
      ref={data.qRef}
      vizRef={data.vizRef}
      palette={colors}
      viz={data.qNo % 2 === 0 ? "bar" : "wave"}>
      <h3 className={classes.heading} ref={data.headingRef}>
        {data.question}
      </h3>
      <div className={classes.grid}>
        {renderOptions(data.qId, data.options, data.lockAnswer)}
      </div>
    </Card>
  )
}

export default withStyles(styles)(Question)
